let scrollButtons = document.querySelectorAll('.scroll_btn');
let eleToScrollCarousel = document.querySelector('.hr_customer_review_scroll');

function scrollToMiddle() {
    if (eleToScrollCarousel) {

      // Calculate the desired scroll position
      const offsetTop = eleToScrollCarousel.offsetTop;
      const middleOffset = offsetTop - window.innerHeight * 0.0;

      // Scroll to the middle offset
      window.scrollTo({
        top: middleOffset,
        // behavior: 'smooth',
      });
    }
  }

scrollButtons.forEach((button) => {
  button.addEventListener("click", () => {
    scrollToMiddle();
  });
});